import { BASE_URL } from '../constants';
import type { ApiRequestUrlOptions } from '../types';

export const buildUrl = (options: ApiRequestUrlOptions) =>
  `${BASE_URL}/v${options.version}/?apikey=${options.apiKey}&lang=${options.lang}`;
